module.exports = __webpack_public_path__ + "static/media/PDF_32.e108ab92.pdf";